import { Column, Columns } from '@codeparva/ui-components-library';
import React from 'react';
import { ClickableText } from '../../../../../../components/clickableText/ClickableText';
import { CTAButtonTypes } from '../../../../../../components/ctaButton/CTAButtonTypes';
import { Gallery } from '../../../../../../components/gallery/Gallery';
import { desktopscreensize } from '../../../../../../utilities/constants';
import { useWindowDimensions } from '../../../../../../utilities/Dimensions';
import { FontAwesomeIcon } from '../../../../../../utilities/iconLoader/FontAwesomeIcon';
import { getFormattedHrs } from '../../../../../sitewide/components/locationMap/LocationMap';
import { HeroTypes } from '../../HeroTypes';
export const FacilityContainer = (location: any) => {
  const { width } = useWindowDimensions();

  const { locations } = location.location;
  const curLocation = locations[0];
  const formattedHrs = getFormattedHrs(curLocation);
  const media = location.photos;

  const GenericIcon = ({ iconName, type }: CTAButtonTypes.TGenericIconType) => {
    const IconContextProps = {
      style: {
        size: 28,
      },
    };
    return (
      <div className="icon-text pb-3 is-align-items-center">
        <span className="icon">
          <FontAwesomeIcon
            iconClassName={iconName}
            iconContextProps={IconContextProps}
          />
        </span>
        <span className="subtitle1">{type}</span>
      </div>
    );
  };
  const GenericTextComponent = ({
    text,
    icon,
    type,
  }: HeroTypes.TGenericTextComponent) => (
    <>
      <GenericIcon iconName={icon} type={type} />
      <ClickableText text={text} type={type} />
    </>
  );
  const getBorderRight = () => {
    return width >= desktopscreensize ? '1px solid #525E75' : '';
  };

  return (
    <>
      <Columns multiline={false} className="is-width-100">
        <Column
          style={{
            borderRight: getBorderRight(),
            flexBasis: 'auto',
            padding: '1.5rem',
          }}
        >
          <div className="facilityVariantSection">
            <div className="pb-3">
              {formattedHrs.officeHrs.length > 0 && (
                <>
                  <div className="iconSection">
                    <FontAwesomeIcon
                      iconClassName="FaDoorClosed"
                      iconContextProps={{
                        className: 'mr-2',
                        style: { fontSize: 28 },
                      }}
                    ></FontAwesomeIcon>
                    <h5>Facility Hours</h5>
                  </div>
                  <>
                    <p className="pb-3">{formattedHrs.officeHrs[0]}</p>
                    <p>{formattedHrs.officeHrs[1]}</p>
                  </>
                </>
              )}
            </div>
            <div>
              {formattedHrs.gateHrs.length > 0 && (
                <>
                  <div className="iconSection">
                    <FontAwesomeIcon
                      iconClassName="FaClock"
                      iconContextProps={{
                        className: 'mr-2',
                        style: { fontSize: 28 },
                      }}
                    ></FontAwesomeIcon>
                    <h5>Access Hours</h5>
                  </div>
                  <>
                    <p className="pb-3">{formattedHrs.gateHrs[0]}</p>
                    <p>{formattedHrs.gateHrs[1]}</p>
                  </>
                </>
              )}
            </div>
          </div>
        </Column>
        <Column
          style={{
            borderRight: getBorderRight(),
            flexBasis: 'auto',
            padding: '1.5rem',
          }}
        >
          <div className="facilityVariantSection">
            <div className="is-flex pb-2">
              <span className="borderLineSection"></span>
              <h5>Contact Details</h5>
            </div>
            <div>
              <div className="pt-3">
                <GenericTextComponent
                  type="phone"
                  text={curLocation.contactNumber}
                  icon="FaPhoneAlt"
                />
              </div>
              <div className="pt-3">
                <GenericTextComponent
                  type="email"
                  text={curLocation.emailAddress}
                  icon="FaRegEnvelope"
                />
              </div>
            </div>
          </div>
        </Column>
        <Column style={{ flexBasis: 'auto', padding: '1.5rem' }}>
          <div className="facilityVariantSection">
            <div className="is-flex pb-3">
              <span className="borderLineSection"></span>
              <h5>Facility Images</h5>
            </div>
            <div>
              <Gallery
                media={media}
                variant="threeImageWithButton"
                maxWidth={256}
              ></Gallery>
            </div>
          </div>
        </Column>
      </Columns>
    </>
  );
};
